import numeral from 'numeral'

export const dollarFormat = num => numeral(num).format('$0,0[.]00')
export const percentFormat = num => numeral(num).format('0%')
export const numberFormat = num => numeral(num).format('0,0')
export const convertToNumberString = val => val ? val.toString().replace(/[^0-9]/g, '') : ''
export const convertToDecimalNumber = val => val ? val.replace(/[^0-9.]/g, '') : (val || '')

export const formatPhoneNumber = phoneString => {
  const p = convertToNumberString(phoneString)
  const m = p.match(/^(\d{3})(\d{3})(\d{4})$/)
  return !m ? p : `(${m[1]}) ${m[2]} - ${m[3]}`
}

export const formatZip = zipString => {
  const z = convertToNumberString(zipString)
  const m = z.match(/^(\d{5})(\d{4})$/)
  return (!m) ? z : `${m[1]}-${m[2]}`
}

